<template>
  <div class="plp-nav-side">
    <div
      v-if="
        categoryList.list && categoryList.list.length && $route.name !== 'plpSearch' && showTypeSide
      "
      class="plp-nav-side__category-list"
    >
      <div
        class="plp-nav-side__sub-item"
        :class="{
          active: !packedCategoryList.some(ele => selectedCodeList.includes(ele.code))
        }"
        @click="onChange([], { type: 'CHECKBOX', code: 'CATEGORY', isAll: true })"
      >
        全部
      </div>
      <div
        v-for="(cell, index) in packedCategoryList"
        :key="index"
        :style="{
          visibility: index > resideuIndex ? 'hidden' : 'visible'
        }"
        class="plp-nav-side__sub-item"
      >
        <div
          v-if="resideuIndex !== index"
          :class="{
            active: !unidirectionSelectedDataStatus && selectedCodeList.includes(cell.code)
          }"
          @click="onChange(cell, { ...categoryList, isAll: false })"
        >
          {{ cell.name }}
        </div>
        <div
          v-else
          :class="{
            active: !unidirectionSelectedDataStatus && inSelectResidueType
          }"
        >
          <popover
            v-model="visible4"
            placement="bottom-end"
            width="240"
            :append-to-body="false"
            trigger="click"
          >
            <span slot="reference">更多</span>
            <div class="popover-box3">
              <div
                v-for="(item, index) in residueTypeList"
                :key="index"
                class="dropdown-item2"
                :class="{
                  'select-1':
                    !unidirectionSelectedDataStatus && selectedCodeList.includes(item.code)
                }"
                @click="(visible4 = false), onChange(item, { ...categoryList, isAll: false })"
              >
                <span style="flex: 1; line-height: 22px">{{ item.name }}</span>
                <svg
                  v-if="!unidirectionSelectedDataStatus && selectedCodeList.includes(item.code)"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style="float: right"
                >
                  <g id="16-1px-SUCEESS">
                    <g id="e">
                      <path
                        id="Vector"
                        d="M14.6668 3.33301L5.78016 12.6663L1.3335 7.99967"
                        stroke="#14141E"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <path
                      id="Vector (Stroke)"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.0116 2.9709C15.2116 3.16131 15.2194 3.4778 15.0289 3.67779L6.14228 13.0111C6.04792 13.1102 5.91709 13.1663 5.78026 13.1663C5.64343 13.1664 5.51257 13.1103 5.41818 13.0113L0.971514 8.34459C0.781021 8.14468 0.788661 7.82819 0.988579 7.63769C1.1885 7.4472 1.50499 7.45484 1.69548 7.65476L5.78003 11.9414L14.3047 2.98823C14.4951 2.78824 14.8116 2.78048 15.0116 2.9709Z"
                      fill="#14141E"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </popover>
        </div>
      </div>
    </div>

    <div class="plp-nav-side__sort">
      <popover v-model="visible1" placement="bottom-start" width="240" trigger="click">
        <span slot="reference" class="plp-nav-side__sort-span">
          <span class="show-text-span" :class="{ 'radio-search': radioSearch == 1 }">
            {{ sort == 'soldQty' ? '销量' : '综合' }}
          </span>
          <svg
            :class="{ rotate: visible1 }"
            class="arrow-down-transition middle"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="16-1px-down-s">
              <path
                id="Vector 2 (Stroke)"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
                fill="#14141E"
              />
            </g>
          </svg>
        </span>
        <div class="popover-box2">
          <div
            class="dropdown-item"
            :class="{ 'select-1': sort == 'sort' }"
            style="align-items: start"
            @click="onSortChangeI('sort')"
          >
            <span style="flex: 1; line-height: 22px">综合</span>
            <svg
              v-if="sort == 'sort'"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="float: right"
            >
              <g id="16-1px-SUCEESS">
                <g id="e">
                  <path
                    id="Vector"
                    d="M14.6668 3.33301L5.78016 12.6663L1.3335 7.99967"
                    stroke="#14141E"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  id="Vector (Stroke)"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0116 2.9709C15.2116 3.16131 15.2194 3.4778 15.0289 3.67779L6.14228 13.0111C6.04792 13.1102 5.91709 13.1663 5.78026 13.1663C5.64343 13.1664 5.51257 13.1103 5.41818 13.0113L0.971514 8.34459C0.781021 8.14468 0.788661 7.82819 0.988579 7.63769C1.1885 7.4472 1.50499 7.45484 1.69548 7.65476L5.78003 11.9414L14.3047 2.98823C14.4951 2.78824 14.8116 2.78048 15.0116 2.9709Z"
                  fill="#14141E"
                />
              </g>
            </svg>
          </div>
          <div
            class="dropdown-item"
            :class="{ 'select-1': sort == 'soldQty' }"
            style="align-items: end"
            @click="onSortChangeI('soldQty')"
          >
            <span style="flex: 1; line-height: 22px">销量</span>
            <svg
              v-if="sort == 'soldQty'"
              width="16"
              height="16"
              margin-bottoppx
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style="float: right"
            >
              <g id="16-1px-SUCEESS">
                <g id="e">
                  <path
                    id="Vector"
                    d="M14.6668 3.33301L5.78016 12.6663L1.3335 7.99967"
                    stroke="#14141E"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <path
                  id="Vector (Stroke)"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M15.0116 2.9709C15.2116 3.16131 15.2194 3.4778 15.0289 3.67779L6.14228 13.0111C6.04792 13.1102 5.91709 13.1663 5.78026 13.1663C5.64343 13.1664 5.51257 13.1103 5.41818 13.0113L0.971514 8.34459C0.781021 8.14468 0.788661 7.82819 0.988579 7.63769C1.1885 7.4472 1.50499 7.45484 1.69548 7.65476L5.78003 11.9414L14.3047 2.98823C14.4951 2.78824 14.8116 2.78048 15.0116 2.9709Z"
                  fill="#14141E"
                />
              </g>
            </svg>
          </div>
        </div>
      </popover>
      <span class="plp-nav-side__sort-span" style="margin-left: 36px" @click="rotatePrice">
        <span class="show-text-span" :class="{ 'radio-search': radioSearch == 2 }">价格</span>
        <svg
          v-if="priceStatus == 0"
          class="middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-&#230;&#142;&#146;&#229;&#186;&#143;">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.3536 6.85209C12.1583 7.04735 11.8417 7.04735 11.6464 6.85209L8 3.20564L4.35355 6.85209C4.15829 7.04735 3.84171 7.04735 3.64645 6.85209C3.45118 6.65683 3.45118 6.34024 3.64645 6.14498L7.64645 2.14498C7.74021 2.05121 7.86739 1.99854 8 1.99854C8.13261 1.99854 8.25979 2.05121 8.35355 2.14498L12.3536 6.14498C12.5488 6.34024 12.5488 6.65683 12.3536 6.85209Z"
              fill="#B4B4BF"
            />
            <path
              id="Vector 3 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 9.14498C3.84171 8.94972 4.15829 8.94972 4.35355 9.14498L8 12.7914L11.6464 9.14498C11.8417 8.94972 12.1583 8.94972 12.3536 9.14498C12.5488 9.34024 12.5488 9.65683 12.3536 9.85209L8.35355 13.8521C8.15829 14.0474 7.84171 14.0474 7.64645 13.8521L3.64645 9.85209C3.45118 9.65683 3.45118 9.34024 3.64645 9.14498Z"
              fill="#B4B4BF"
            />
          </g>
        </svg>
        <svg
          v-if="priceStatus == 1 || priceStatus == 2"
          :class="{ rotate: priceStatus === 1 }"
          class="middle"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="16-1px-&#230;&#142;&#146;&#229;&#186;&#143;-2">
            <path
              id="Vector 2 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.3536 6.85209C12.1583 7.04735 11.8417 7.04735 11.6464 6.85209L8 3.20564L4.35355 6.85209C4.15829 7.04735 3.84171 7.04735 3.64645 6.85209C3.45118 6.65683 3.45118 6.34024 3.64645 6.14498L7.64645 2.14498C7.74021 2.05121 7.86739 1.99854 8 1.99854C8.13261 1.99854 8.25979 2.05121 8.35355 2.14498L12.3536 6.14498C12.5488 6.34024 12.5488 6.65683 12.3536 6.85209Z"
              fill="#B4B4BF"
            />
            <path
              id="Vector 3 (Stroke)"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.64645 9.14498C3.84171 8.94972 4.15829 8.94972 4.35355 9.14498L8 12.7914L11.6464 9.14498C11.8417 8.94972 12.1583 8.94972 12.3536 9.14498C12.5488 9.34024 12.5488 9.65683 12.3536 9.85209L8.35355 13.8521C8.15829 14.0474 7.84171 14.0474 7.64645 13.8521L3.64645 9.85209C3.45118 9.65683 3.45118 9.34024 3.64645 9.14498Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
      <popover
        v-if="sexList.list && sexList.list.length > 1"
        v-model="visible3"
        placement="bottom-start"
        width="400"
        title="性别"
        trigger="click"
        class="size-popover"
      >
        <span slot="reference" class="plp-nav-side__sort-span" style="margin-left: 36px">
          <span
            class="show-text-span"
            :class="{ 'radio-search': selSexList && selSexList.length > 0 }"
          >
            {{
              selSexList && selSexList.length > 0
                ? selSexList
                    .map(ele => {
                      return ele.name;
                    })
                    .join('/')
                : '性别'
            }}
          </span>
          <svg
            :class="{ rotate: visible3 }"
            class="arrow-down-transition middle"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="16-1px-down-s">
              <path
                id="Vector 2 (Stroke)"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
                fill="#14141E"
              />
            </g>
          </svg>
        </span>
        <div class="popover-box">
          <PdtSizePicker
            v-model="bindValue2"
            :option="sexList.list || []"
            multiple
            label-key="name"
            value-key="code"
          />
        </div>
        <div class="popover-bottom">
          <GtButton
            size="medium"
            type="text"
            class="popover-bottom__cancel"
            @click.capture="handleSelect2(false)"
          >
            重置
          </GtButton>
          <GtButton
            size="medium"
            type="primary"
            class="popover-bottom__confirm"
            @click.capture="handleSelect2(true)"
          >
            确定
          </GtButton>
        </div>
      </popover>
      <popover
        v-model="visible2"
        placement="bottom-start"
        title="尺码"
        width="400"
        trigger="click"
        class="size-popover"
      >
        <span slot="reference" class="plp-nav-side__sort-span" style="margin-left: 36px">
          <span
            class="show-text-span"
            :class="{ 'radio-search': selSizeList.list && selSizeList.length > 0 }"
          >
            {{
              selSizeList && selSizeList.length > 0
                ? selSizeList
                    .map(ele => {
                      return ele.name;
                    })
                    .join('/')
                : '尺码'
            }}
          </span>
          <svg
            :class="{ rotate: visible2 }"
            class="arrow-down-transition middle"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="16-1px-down-s">
              <path
                id="Vector 2 (Stroke)"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45119 12.1583 5.45119 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45119 6.15829 3.45119 5.84171 3.64645 5.64645Z"
                fill="#14141E"
              />
            </g>
          </svg>
        </span>
        <div class="popover-box">
          <PdtSizePicker
            v-model="bindValue"
            :option="sizeList.list || []"
            multiple
            label-key="name"
            value-key="code"
          />
        </div>
        <div class="popover-bottom">
          <GtButton
            size="medium"
            type="text"
            class="popover-bottom__cancel"
            @click.capture="handleSelect(false)"
          >
            重置
          </GtButton>
          <GtButton
            size="medium"
            type="primary"
            class="popover-bottom__confirm"
            @click.capture="handleSelect(true)"
          >
            确定
          </GtButton>
        </div>
      </popover>
      <span class="plp-nav-side__sort-span" style="margin-left: 36px" @click="selectNewProduct()">
        <span class="show-text-span" :class="{ 'radio-search': radioSearch == 3 }">新品</span>
      </span>
      <span class="plp-nav-side__sort-span" style="margin-left: auto" @click="clickFilterButton">
        <span class="show-text-span">筛选</span>
        <svg
          class="middle"
          width="14"
          height="12"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Group 16">
            <path
              id="Union"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.5 8.99951C13.7761 8.99951 14 9.22337 14 9.49951C14 9.77565 13.7761 9.99951 13.5 9.99951H11.1035C10.8815 10.8621 10.0984 11.4995 9.1665 11.4995C8.23458 11.4995 7.45154 10.8621 7.22951 9.99951H0.5C0.223857 9.99951 0 9.77565 0 9.49951C0 9.22337 0.223858 8.99951 0.5 8.99951H7.22951C7.45153 8.1369 8.23458 7.49951 9.1665 7.49951C10.0984 7.49951 10.8815 8.1369 11.1035 8.99951H13.5ZM8.1665 9.49951C8.1665 10.0518 8.61422 10.4995 9.1665 10.4995C9.71879 10.4995 10.1665 10.0518 10.1665 9.49951C10.1665 8.94723 9.71879 8.49951 9.1665 8.49951C8.61422 8.49951 8.1665 8.94723 8.1665 9.49951Z"
              fill="#14141E"
            />
            <path
              id="Union_2"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5 2.99951C0.223858 2.99951 0 2.77565 0 2.49951C0 2.22337 0.223858 1.99951 0.5 1.99951H2.8965C3.11853 1.1369 3.90158 0.499512 4.8335 0.499512C5.76542 0.499512 6.54846 1.1369 6.77049 1.99951H13.5C13.7761 1.99951 14 2.22337 14 2.49951C14 2.77565 13.7761 2.99951 13.5 2.99951H6.77049C6.54847 3.86212 5.76542 4.49951 4.8335 4.49951C3.90158 4.49951 3.11853 3.86213 2.8965 2.99951H0.5ZM5.8335 2.49951C5.8335 1.94723 5.38578 1.49951 4.8335 1.49951C4.28121 1.49951 3.8335 1.94723 3.8335 2.49951C3.8335 3.0518 4.28121 3.49951 4.8335 3.49951C5.38578 3.49951 5.8335 3.0518 5.8335 2.49951Z"
              fill="#14141E"
            />
          </g>
        </svg>
      </span>
    </div>
    <PlpDrawer
      ref="plp-drawer"
      :total-count="totalCount"
      :on-filter="onFilter"
      :filter-data="filterData"
      :reset-filter-data="resetFilterData"
      :params="params"
      :show-type-side="showTypeSide"
      :unidirection-selected-data-status="unidirectionSelectedDataStatus"
      @onSelected="onSelected"
      @mergeOption="mergeOption"
      @resetParentFilterOption="resetParentFilterOption"
    ></PlpDrawer>
  </div>
</template>

<script>
import { GtButton } from '@speedshop/template';

import { Popover } from 'element-ui';
import { CatalogProduct, CatalogWcmProduct } from '@/utils/product';
import PdtSizePicker from '@/components/PDP/SizePicker.vue';
import PlpDrawer from '@/components/PLP/drawer.vue';
import { scrollToTop } from '@/utils/dom';

export default {
  components: {
    Popover,
    PdtSizePicker,
    PlpDrawer,
    GtButton
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    },
    filterData: {
      type: Array,
      default: () => []
    },

    onFilter: {},
    totalCount: {},
    resetFilterData: {},
    params: {},
    showTypeSide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const item = (this.data || []).find(item => JSON.stringify(item).includes(this.$route.path));
    return {
      activeList: item ? [item.navigationCode] : [],
      selectedData: {},
      visible1: false,
      visible2: false,
      visible3: false,
      visible4: false,
      bindValue: [],
      bindValue2: [],
      sort: 'sort',
      SortMapping: {
        sort: { name: '默认', index: 0 },
        firstOnboardTime: { name: '最新', index: 1 },
        soldQty: { name: '热卖', index: 2 },
        'price-0': { name: '价格从低到高', index: 3 },
        'price-1': { name: '价格从高到低', index: 4 }
      },
      priceStatus: 0,
      radioSearch: 1,
      unidirectionSelectedDataStatus: false,
      residueTypeList: [],
      resideuIndex: 0
      // packedCategoryListAndMoreArray: []
    };
  },
  computed: {
    mainData() {
      return this.data.slice(0, this.data.length - 1);
    },
    recommendData() {
      const data = this.data[this.data.length - 1];
      return data && data.children ? data.children : [];
    },

    selectedCodeList() {
      return this.selectedList.map(i => i.code);
    },
    categoryList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      function findSecondLastChildrenWithChildren(tree) {
        const secondLastChildrenWithChildren = [];

        function traverse(node, depth) {
          if (!node.list || node.list.length === 0) {
            return;
          }
          const firstChild = node.list[0];

          if (firstChild.list && firstChild.list.length) {
            for (const child of node.list) {
              traverse(child, depth - 1);
            }
          } else {
            secondLastChildrenWithChildren.push(node);
          }

          // if (depth === 1) {
          //   secondLastChildrenWithChildren.push(node);
          //   return;
          // }

          // for (const child of node.list) {
          //   traverse(child, depth - 1);
          // }
        }

        for (const root of tree) {
          traverse(root, 2);
        }

        return secondLastChildrenWithChildren;
      }

      const { list = [], ...others } = data;

      const newList = list.map(item => {
        const children = item.children.map(i => {
          return {
            ...i,
            list: (i.list || i.children || []).map(e => {
              return {
                ...e,
                list: (e.list || e.children || []).map(c => {
                  return {
                    ...c,
                    list: c.list || c.children,
                    name: c.name || c.categoryName
                  };
                }),
                name: e.name || e.categoryName
              };
            }),
            name: i.name || i.categoryName
          };
        });
        return {
          ...item,
          list: children,
          name: item.name || item.categoryName
        };
      });
      const { categoryCode, categoryCodeList = [] } = this.params || {};
      const filterCategory = [categoryCode, ...categoryCodeList].filter(i => i);
      const secondLastChildrenWithChildren = findSecondLastChildrenWithChildren(newList);
      // 过滤categoryCode
      const filterNoMatchData = secondLastChildrenWithChildren;
      // const filterNoMatchData = !filterCategory.length
      //   ? secondLastChildrenWithChildren
      //   : secondLastChildrenWithChildren.filter(i => {
      //       const matchChildren = i.list.some(c => {
      //         const pathCodeList = c.categoryPath?.split('>') || [];
      //         return filterCategory.some(e => {
      //           return pathCodeList.includes(e);
      //         });
      //       });
      //       return matchChildren;
      //     });
      // 去重
      const myMap = new Map();
      filterNoMatchData.forEach(item => {
        const { name, list } = item;
        if (myMap.has(name)) {
          const data = myMap.get(name);
          list.forEach(i => {
            data.listMap.set(i.name, i);
          });
          myMap.set(name, { ...data, list: newList });
        } else {
          const listMap = new Map();
          list.forEach(i => {
            listMap.set(i.name, i);
          });
          myMap.set(name, { ...item, listMap });
        }
      });
      const newListMap = [...myMap.values()];
      const resultList = newListMap.map(i => {
        return {
          ...i,
          list: [...i.listMap.values()].map(item => {
            return {
              ...item,
              originalCode: item.categoryCode,
              categoryCode: item?.name,
              code: item?.name,
              attrCate: 'CATEGORY'
            };
          })
        };
      });
      return {
        ...others,
        list: resultList
      };
    },

    selectedList() {
      let list = [];
      for (const key in this.selectedData) {
        if (key === 'PRICE' && this.selectedData[key].length) {
          const price = this.selectedData[key][0];
          list = [...list, [{ name: price.join('-'), parentCode: 'PRICE' }]];
        } else {
          list = [...list, this.selectedData[key]];
        }
      }
      const data = list;
      const result = data.reduce((result, item) => {
        return [...result, ...item];
      }, []);
      return result;
    },

    sizeList() {
      const list = this.filterData.find(i => i.code === 'SIZE') || {};

      return list;
    },
    sortList() {
      const data = (this.filterData && this.filterData.find(i => i.code === 'SORT')) || {};
      let { list } = data;
      if (list && list.length) {
        list = [
          { code: 'sort', value: { name: 'sort', sort: '0' }, parentCode: 'Sort' },
          { code: 'soldQty', value: { name: 'soldQty', sort: '1' }, parentCode: 'Sort' },
          {
            code: 'firstOnboardTime',
            value: { name: 'firstOnboardTime', sort: '1' },
            parentCode: 'Sort'
          },
          ...list
        ]
          .filter(i => !['onboardTime-0', 'onboardTime-1'].includes(i.code))
          .map(item => {
            return {
              ...item,
              name: this.SortMapping[item.code]?.name
            };
          });
        list.sort((a, b) => {
          return this.SortMapping[a.code].index > this.SortMapping[b.code].index ? 1 : -1;
        });
        return { ...data, list };
      } else {
        return [];
      }
    },
    sexList() {
      const list = this.filterData.find(i => i.code === 'PDP_SEX') || {};

      return list;
    },
    tagList() {
      // return (this.filterData && this.filterData.find(i => i.code === 'TAG')) || {};
      // 写死tag
      return {
        attrCate: null,
        code: 'TAG',
        list: [
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '新品',
            displayName: '新品推荐',
            name: '新品推荐',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '新品',
            tagName: '新品推荐'
          },
          {
            attrCate: null,
            attrType: undefined,
            checked: false,
            code: '热卖',
            displayName: '热卖商品',
            name: '热卖商品',
            parentCode: 'Tag',
            parentName: 'Tag',
            status: '1',
            tagCode: '热卖',
            tagName: '热卖商品'
          }
        ],
        name: 'Tag',
        type: 'CHECKBOX'
      };
    },
    selSexList() {
      return this.selectedData.PDP_SEX ? this.selectedData.PDP_SEX : [];
    },
    selSizeList() {
      return this.selectedData.SIZE ? this.selectedData.SIZE : [];
    },
    filterSideIsSticky() {
      return this.$store.state.filterSideIsSticky;
    },
    inSelectResidueType() {
      const filterData = this.residueTypeList.filter(ele => {
        return this.selectedCodeList.includes(ele.code);
      });
      return filterData && filterData.length > 0;
    },
    packedCategoryList() {
      return this.categoryList.list.reduce((res, i) => res.concat(i.list), []);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const dom = document.querySelector('.plp-nav-side__category-list');
      const dom2 = document.querySelectorAll('.plp-nav-side__sub-item');
      if (dom && dom2) {
        this.computedNavWidthOverflow();
        const observer = new ResizeObserver(() => {
          requestAnimationFrame(() => {
            this.computedNavWidthOverflow();
          });
        });
        observer.observe(dom);
      }
    });
  },
  methods: {
    computedNavWidthOverflow() {
      const dom = document.querySelector('.plp-nav-side__category-list');
      const items = document.querySelectorAll('.plp-nav-side__sub-item');
      const { right: cRight } = dom?.getBoundingClientRect?.() || {};
      this.resideuIndex = this.packedCategoryList.length - 1;
      for (let i = 0; i < items.length; i++) {
        const { right } = items[i].getBoundingClientRect();
        if (right > cRight - 32 - 48) {
          this.resideuIndex = i - 1;
          break;
        }
      }
      this.residueTypeList = this.packedCategoryList.slice(this.resideuIndex);
    },
    // computedNavWidthOverflow() {
    //   // 获取全部的筛选字段，叠加计算宽度
    //   const dom = document.querySelector('.plp-nav-side__category-list');
    //   const dom2 = document.querySelectorAll('.plp-nav-side__sub-item');
    //   this.packedCategoryListAndMoreArray = [];
    //   if (dom && dom2) {
    //     // 容器宽度
    //     const boxWidth = dom.clientWidth;
    //     // 前置item的宽度和
    //     let childWidthCount = 0;
    //     this.residueTypeList = [];
    //     let isAddMoreButtonTiming = 0;
    //     let packedCategoryListAndMoreArray = this.packedCategoryList();
    //     dom2.forEach((ele, index) => {
    //       // 当前item的宽度
    //       const computedWidth =
    //         childWidthCount +
    //         ele.clientWidth +
    //         48 +
    //         (index < dom2.length - 1 ? dom2[index + 1].clientWidth + 48 : 0);
    //       const computedAddMoreButtonWidth =
    //         childWidthCount + ele.clientWidth + 48 + (index < dom2.length - 1 ? 32 : 0);
    //       const computedNoAddMoreButtonWidth = childWidthCount + ele.clientWidth + 48;

    //       if (
    //         boxWidth < computedAddMoreButtonWidth &&
    //         isAddMoreButtonTiming === 0 &&
    //         boxWidth >= computedNoAddMoreButtonWidth
    //       ) {
    //         const resideType = packedCategoryListAndMoreArray.find(pitem => {
    //           return (
    //             (pitem.categoryNam || pitem?.name) ===
    //             (index < dom2.length - 1 ? dom2[index + 1].textContent.trim() : null)
    //           );
    //         });
    //         const resideType2 = packedCategoryListAndMoreArray.find(pitem => {
    //           return (
    //             (pitem.categoryNam || pitem?.name) ===
    //             (index < dom2.length - 1 ? dom2[index].textContent.trim() : null)
    //           );
    //         });
    //         if (resideType2) {
    //           this.residueTypeList.push(resideType2);
    //         }
    //         if (resideType) {
    //           this.residueTypeList.push(resideType);
    //         }
    //         ++isAddMoreButtonTiming;
    //         if (isAddMoreButtonTiming === 1) {
    //           packedCategoryListAndMoreArray.splice(index - 1, 0, {
    //             code: '更多'
    //           });
    //         }
    //       } else if (boxWidth < computedWidth) {
    //         const resideType = packedCategoryListAndMoreArray.find(pitem => {
    //           return (
    //             (pitem.categoryNam || pitem?.name) ===
    //             (index < dom2.length - 1 ? dom2[index + 1].textContent.trim() : null)
    //           );
    //         });
    //         if (resideType) {
    //           this.residueTypeList.push(resideType);
    //         }
    //         ++isAddMoreButtonTiming;
    //         if (isAddMoreButtonTiming === 1) {
    //           packedCategoryListAndMoreArray.splice(index, 0, {
    //             code: '更多'
    //           });
    //         }
    //       }
    //       childWidthCount = childWidthCount + ele.clientWidth + 48;
    //     });
    //     const index = packedCategoryListAndMoreArray.findIndex(item => item.code === '更多');
    //     if (index !== -1) {
    //       // 截取数组，保留从头到找到的对象为止的部分
    //       this.packedCategoryListAndMoreArray = packedCategoryListAndMoreArray.slice(0, index + 1);
    //     } else {
    //       // 截取数组，保留从头到找到的对象为止的部分
    //       this.packedCategoryListAndMoreArray = packedCategoryListAndMoreArray;
    //     }
    //   }
    // },
    onChange(data, item) {
      const code = ['SLIDER'].includes(item.type)
        ? item.code
        : item.code === 'CATEGORY'
        ? item.code
        : data.parentCode;
      if (item.type === 'CHECKBOX') {
        if (item.code === 'CATEGORY') {
          if (item.isAll) {
            this.$set(this.selectedData, code, []);
          } else {
            this.$set(this.selectedData, code, [data]);
          }
          this.unidirectionSelectedDataStatus = false;
        } else {
          const checkedData = this.selectedData[code];
          if (checkedData) {
            const index = checkedData.findIndex(i => {
              return i.code === data.code;
            });
            index > -1 ? checkedData.splice(index, 1) : this.selectedData[code].push(data);
          } else {
            this.$set(this.selectedData, code, [data]);
          }
        }
        // this.$set(this.selectedData, code, [data]);
      } else if (item.type === 'SLIDER') {
        this.$set(this.selectedData, code, [data]);
      } else if (item.type === 'SELECT') {
        const checkedData = this.selectedData[code];
        if (checkedData) {
          const index = checkedData.findIndex(i => {
            return i.code === data.code;
          });
          index < 0 && this.selectedData[code].push(data);
        } else {
          this.$set(this.selectedData, code, [data]);
        }
      } else {
        this.$set(this.selectedData, code, [data]);
      }
      if (this.isMobile) {
        this.queryProductNum();
      } else {
        this.onFilter(this.selectedData[code], item);
        this.backToTop();
      }
      this.trackData(data?.name);
      this.$emit('onSelected', this.selectedList);
    },

    async queryProductNum() {
      const categoryCodeList = this.selectedData.CATEGORY || [];
      const attrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SKUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });
      const spuAttrList = Object.keys(this.selectedData)
        .filter(i => {
          if (!this.selectedData[i] || !this.selectedData[i].length) return false;
          return this.selectedData[i][0].attrCate === 'SPUATTR';
        })
        .map(i => {
          const data = this.selectedData[i];
          const item = data[0];
          return {
            attrCode: i,
            attrType: item.attrType,
            attrValue: data.map(e => {
              return e.valueCode;
            })
          };
        });

      const sendData = {
        numberFilter: 'salePrice',
        categoryCodeList: categoryCodeList.map(i => i.code) || [],
        brandCodeList: [],
        fqList: [{ fq: 'ra', key: 'salePrice', value: this.priceRange.toString() }],
        attrList,
        spuAttrList
      };

      this.loading = true;
      // 初始化

      const plp = ['home', 'LandingPage', 'LandingPage-all'].includes(this.$route.name)
        ? CatalogWcmProduct()
        : CatalogProduct();
      plp.init({
        categoryExtCode: this.$route.params.category,
        hasFilter: false,
        conditionKeyword: this.$route.query.searchWord || ''
      });
      const {
        pageInfo: { totalCount }
      } = await plp?.checkCondition(sendData);
      this.$emit('changeTotalCount', totalCount);
    },

    backToTop() {
      // 回到顶部

      // const $scroll = document.querySelector('.sp-wrapper-scroll');
      // const adContainer = document.querySelector('.ad-page-top');
      // const adHeight = adContainer ? adContainer.offsetHeight : 0;

      // $scroll && $scroll.scrollTo(0, adHeight);
      // setTimeout(() => {
      //   const leftContainer = document.querySelector('.page-plp_filter-side');
      //   const leftContainerParent = document.querySelector('.page-plp-left');
      //   if (leftContainer) {
      //     // leftContainer.style.position = 'relative';
      //     // leftContainer.style.bottom = '0px';

      //     // leftContainer.style.top = '0px';
      //     // leftContainer.style.height = 'auto';
      //     // leftContainerParent.style.display = 'block';
      //     // leftContainerParent.style.height = 'auto';
      //     leftContainerParent.classList.remove('flex');
      //     leftContainerParent.classList.remove('fixed');
      //     leftContainerParent.classList.remove('sticky');
      //     leftContainerParent.classList.add('relative');
      //     leftContainerParent.style.height = 'auto';
      //   }
      // }, 500);
      // scrollToTop();
      if (this.filterSideIsSticky) {
        // 筛选栏吸顶，滚动到筛选栏，筛选栏未吸顶，不做操作
        const $scroll = document.querySelector('html'); // 整个页面滚动至 筛选栏吸顶位置
        // 获取 top title 和 filterbar 元素
        const topTitleElement = this.isMobile
          ? document.querySelector('.mobile_header-layer')
          : document.querySelector('.gt-header');
        const topPlpElement = document.querySelector('.slot-page-plp-top'); // 筛选栏的title：xx拖鞋 xx件商品
        const topPlpElement2 = document.querySelector('.count-topAd-class'); // 顶部slide图
        // 计算元素高度
        const topTitleHeight = topTitleElement?.offsetHeight || 0;
        const topPlpHeight = topPlpElement?.offsetHeight || 0;
        const topPlpHeight2 = topPlpElement2?.offsetHeight || 0;
        // 设置触发吸顶的位置
        const triggerPosition =
          (this.isMobile ? topTitleHeight : 12) + topPlpHeight + topPlpHeight2;
        $scroll && $scroll.scrollTo(0, triggerPosition);
      }
    },
    trackData(name) {
      const data = (this.filterData && this.filterData.find(i => i.code === 'CATEGORY')) || {};
      const { list = [] } = data;
      const primary_category = list.length && list[0];
      const secondary_category = primary_category?.children?.length && primary_category.children[0];
      const third_category = secondary_category?.list?.length && secondary_category.list[0];
      this.$trackHelp.track('productScreen', {
        belong_page: '商品列表页',
        primary_category: primary_category?.categoryName,
        secondary_category: secondary_category?.name,
        third_category: third_category?.categoryName,
        list_name: name
      });
    },
    handleSelect(status) {
      if (status && this.bindValue.length) {
        this.$set(this.selectedData, this.sizeList.code, []);
        const length = this.bindValue.length;
        this.bindValue.forEach((ele, index) => {
          const obj = this.sizeList.list.find(item => {
            return item.code === ele;
          });
          if (length - 1 > index) {
            if (this.selectedData[this.sizeList.code]) {
              this.selectedData[this.sizeList.code].push(obj);
              this.$set(
                this.selectedData,
                this.sizeList.code,
                this.selectedData[this.sizeList.code]
              );
            } else {
              this.$set(this.selectedData, this.sizeList.code, [obj]);
            }
          } else {
            this.onChange(obj, this.sizeList);
          }
        });
        this.visible2 = false;
      } else if (status && this.bindValue.length === 0) {
        this.$set(this.selectedData, this.sizeList.code, []);
        this.onFilter(this.selectedData[this.sizeList.code], this.sizeList);
        this.visible2 = false;
      } else if (!status) {
        this.$set(this.selectedData, this.sizeList.code, []);
        this.bindValue = [];
      }
      // else if (!status && this.bindValue.length) {
      //   this.$set(this.selectedData, this.sizeList.code, []);
      //   this.bindValue = [];
      // }
    },
    handleSelect2(status) {
      if (status && this.bindValue2.length) {
        this.$set(this.selectedData, this.sexList.code, []);
        const length = this.bindValue2.length;
        this.bindValue2.forEach((ele, index) => {
          const obj = this.sexList.list.find(item => {
            return item.code === ele;
          });
          if (length - 1 > index) {
            if (this.selectedData[this.sexList.code]) {
              this.selectedData[this.sexList.code].push(obj);
              this.$set(this.selectedData, this.sexList.code, this.selectedData[this.sexList.code]);
            } else {
              this.$set(this.selectedData, this.sexList.code, [obj]);
            }
          } else {
            this.onChange(obj, this.sexList);
          }
        });
        this.visible3 = false;
      } else if (status && this.bindValue2.length === 0) {
        this.$set(this.selectedData, this.sexList.code, []);
        this.onFilter(this.selectedData[this.sexList.code], this.sexList);
        this.visible3 = false;
      } else if (!status) {
        this.$set(this.selectedData, this.sexList.code, []);
        this.bindValue2 = [];
      }
      //  else if (!status && this.bindValue2.length) {
      //   this.$set(this.selectedData, this.sexList.code, []);
      //   this.bindValue2 = [];
      // }
    },
    onSortChangeI(code) {
      this.priceStatus = 0;
      this.radioSearch = 1;

      this.visible1 = false;
      this.onSortChange(code);
    },
    onSortChange(code) {
      this.sort = code;
      const data = this.sortList.list.find(i => i.code === code);
      this.onChange(data, this.sortList);
    },
    rotatePrice() {
      if (this.priceStatus === 0) {
        this.priceStatus = 1;
        this.radioSearch = 2;
        // 低到高
        this.onSortChange('price-0');
      } else if (this.priceStatus === 1) {
        this.priceStatus = 2;
        this.radioSearch = 2;
        // 高到低
        this.onSortChange('price-1');
      } else if (this.priceStatus === 2) {
        this.priceStatus = 0;
        this.radioSearch = 1;
        this.onSortChangeI('sort');
      }
    },
    selectNewProduct() {
      this.priceStatus = 0;
      this.sort = 'sort';
      this.radioSearch = 3;
      this.onSortChange('firstOnboardTime');
    },
    onSelected(val) {
      this.$emit('onSelected', val);
    },
    clickFilterButton() {
      this.$refs['plp-drawer'].clickFilterButton(this.bindValue, this.selectedData);
      this.$refs['plp-drawer'].drawer = true;
    },
    mergeOption(sizeBindValue, sexBindValue, selectedData) {
      this.$nextTick(() => {
        this.bindValue = sizeBindValue || [];
        this.bindValue2 = sexBindValue || [];
        this.$set(this.selectedData, 'SIZE', selectedData.SIZE || []);
        this.$set(this.selectedData, 'PDP_SEX', selectedData.PDP_SEX || []);
        // fix hint 弹框的产品状态不传递到外层的nav side
        this.unidirectionSelectedDataStatus = true;
        this.$set(this.selectedData, 'CATEGORY', selectedData.CATEGORY || []);

        // 将子组件drawer的筛选项合并到当前组件的this.selectedData中
        this.$set(selectedData, 'Sort', this.selectedData.Sort || []);
        for (const key in selectedData) {
          this.$set(this.selectedData, key, selectedData[key] || []);
        }
      });
    },
    resetParentFilterOption() {
      this.$nextTick(() => {
        this.selectedData = {};
        this.radioSearch = 1;
        this.priceStatus = 0;
        this.bindValue = [];
        this.bindValue2 = [];
        this.$set(this.selectedData, 'PDP_SEX', []);
        this.$set(this.selectedData, 'SIZE', []);
        this.resetFilterData();
      });
    }
    // packedCategoryList() {
    //   let list = [];
    //   this.categoryList.list.forEach(ele => {
    //     list = list.concat(ele.list);
    //   });
    //   console.log(
    //     'packedCategoryList',
    //     list.map(ele => {
    //       return ele.categoryName || ele.name;
    //     })
    //   );
    //   return list;
    // }
  }
};
</script>

<style lang="scss" scoped>
.plp-nav-side {
  width: 100%;
  &__category-list {
    height: 32px;
    white-space: nowrap;
    // overflow-x: hidden;
    margin-bottom: 24px;
    position: relative;
  }
  /* 隐藏滚动条轨道 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  /* 隐藏滚动条的 thumb（拖动滑块） */
  ::-webkit-scrollbar-thumb {
    background: transparent; /* 使滑块透明 */
  }
  .active {
    color: var(--main-color-ua-dark-grey, #14141e);
    text-align: center;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    height: 22px;
    text-transform: capitalize;
    position: relative; /* 让伪元素相对于父元素定位 */
    display: inline-block; /* 使 div 仅占用所包含文本的宽度 */
  }
  .active::after {
    content: ''; /* 伪元素内容为空 */
    display: inline-block; /* 将伪元素变为块级元素，以占据一行 */
    width: 100%; /* 横杠的宽度与父元素宽度相同 */
    height: 4px; /* 横杠的高度 */
    background-color: #dc0019; /* 横杠的颜色 */
    position: absolute; /* 使伪元素相对于父元素绝对定位 */
    bottom: 0; /* 将伪元素置于底部 */
    left: 0; /* 伪元素与父元素左侧对齐 */
    top: 21px;
  }
  &__sub-item {
    display: inline-block;
    color: var(--secondary-color-ua-cool-grey-03, #8c8c96);
    text-align: center;
    cursor: pointer;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    height: 22px;
    text-transform: capitalize;
  }
  &__sub-item:not(:first-of-type) {
    margin-left: 48px;
  }
  &__sub-item-context-box {
    // width: calc(100% - 32px);
    overflow: hidden;
    display: inline-block;
    height: 26px;
  }
  &__sort {
    display: flex;
    // margin-top: 24px;
    height: 22px;
    line-height: 22px;
    .radio-search {
      overflow: hidden;
      color: var(--main-color-ua-dark-grey, #14141e);
      text-overflow: ellipsis;

      /* cn/pingfang/bold/16 */
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 22px; /* 137.5% */
      text-transform: capitalize;
    }
  }
  &__sort-span {
    color: var(--main-color-ua-dark-grey, #14141e);
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    text-transform: capitalize;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .show-text-span {
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  }

  .middle {
    vertical-align: middle;
    margin: 3px 0 0 8px;
  }
  .dropdown-menu {
    padding: 24px;
    margin-top: 30px;
  }
  .arrow-down-transition {
    transition: all 0.5s;
  }
  .rotate {
    transform: rotate(180deg);
  }
}
.more-btn__wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: var(--main-color-ua-white, #fff);
}
</style>
<style lang="scss">
.el-popover {
  // padding: 24px 24px 32px 24px !important;
  padding: 0 !important;
}
.el-popover__title {
  margin-bottom: 16px !important;
  color: var(--main-color-ua-dark-grey, #14141e);

  font-family: PingFang SC;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  text-transform: capitalize;
  padding: 24px 24px 0 24px;
}
.popover-box {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  min-height: 38px;
  max-height: 220px;
  overflow: auto;
  padding: 0 24px;
  .popover-item {
    display: inline-block;
    border: 1px solid #dddddd;
    width: 78px;
    padding: 10px 0;
    text-align: center;
  }
}
.popover-bottom {
  margin-top: 28px;
  display: flex;
  padding: 0 24px 32px 24px;
  &__cancel {
    width: 172px;
    height: 38px !important;
    border-radius: 1px !important;
    border: 1px solid var(--main-color-ua-dark-grey, #14141e) !important;
    font-family: PingFang SC;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: 20px !important;
    text-transform: capitalize;
  }
  &__confirm {
    width: 172px;
    height: 38px !important;
    margin-left: 8px;
    border-radius: 1px !important;
    background: var(--main-color-ua-dark-grey, #14141e) !important;
    color: var(--main-color-ua-white, #fff) !important;
    font-family: PingFang SC;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: 20px !important;
    text-transform: capitalize;
  }
}
.dropdown-item {
  width: 192px;
  display: inline-block;
  display: flex;
  align-items: center;
  color: var(--secondary-color-ua-cool-grey-04, #50505a);

  font-family: PingFang SC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
  height: 42px;
  text-transform: capitalize;
  cursor: pointer;
}
.dropdown-item:not(:first-of-type) {
  border-top: 1px solid #eeeeee;
}
.dropdown-item2 {
  width: 192px;
  display: inline-block;
  display: flex;
  align-items: center;
  color: var(--secondary-color-ua-cool-grey-04, #50505a);

  font-family: PingFang SC;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 62px;
  height: 62px;
  text-transform: capitalize;
  cursor: pointer;
}
.dropdown-item2:not(:first-of-type) {
  border-top: 1px solid #eeeeee;
}
.popover-box2 {
  padding: 24px 24px 32px 24px;
  background: white;
}
.popover-box3 {
  padding: 14px 24px 22px 24px;
  background: white;
  max-height: 400px;
  overflow: auto;
}
.select-1 {
  color: var(--secondary-color-ua-cool-grey-04, #14141e);
  font-weight: 600;
}

/* 隐藏滚动条本身，但保留滚动效果 */
/* 仅适用于支持 WebKit 的浏览器 */

/* 隐藏滚动条轨道 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* 隐藏滚动条的 thumb（拖动滑块） */
::-webkit-scrollbar-thumb {
  background: black; /* 使滑块透明 */
}
</style>
<style lang="scss" layout="mobile">
.page-layout_mobile {
  &__category-list {
    margin-bottom: 20px;
  }
  .middle {
    vertical-align: middle;
    margin: 1px 0 0 4px;
  }
}
</style>
